import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import { apiClient } from "@/lib/api";
import { Trophy, Flame } from "lucide-react";

export default function Leaderboard() {
  const [users, setUsers] = useState([]);
  useEffect(() => {
    (async () => {
      const r = await apiClient.get("/leaderboard");
      setUsers(r.data.users || []);
    })();
  }, []);
  return (
    <div className="App min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-14 pb-28 md:pb-14">
        <span className="kicker">This week</span>
        <h1 className="font-display text-5xl md:text-6xl mt-3 leading-[1.05] tracking-tight">Top <em>Promptsmiths</em></h1>
        <div className="mt-9 brut overflow-hidden">
          {users.length === 0 && (
            <div className="p-8 text-center text-[var(--ink-2)] text-sm">No rankings yet — be first!</div>
          )}
          {users.map((u, i) => (
            <div
              key={u.user_id}
              data-testid={`leaderboard-row-${i + 1}`}
              className={`flex items-center justify-between p-5 ${i < users.length - 1 ? "border-b border-[var(--line)]" : ""}`}
              style={i === 0 ? { background: "linear-gradient(90deg, rgba(255,92,42,0.06) 0%, transparent 80%)" } : {}}
            >
              <div className="flex items-center gap-4">
                <div
                  className="w-9 h-9 rounded-full flex items-center justify-center font-display text-lg"
                  style={{ background: i === 0 ? "var(--accent)" : "var(--bg-2)", color: i === 0 ? "#fff" : "var(--ink)" }}
                >
                  {i + 1}
                </div>
                {u.picture ? (
                  <img src={u.picture} alt="" className="w-9 h-9 rounded-full" />
                ) : (
                  <div className="w-9 h-9 rounded-full bg-[var(--bg-2)]" />
                )}
                <div>
                  <div className="font-medium">{u.name}</div>
                  <div className="text-xs text-[var(--ink-2)] flex items-center gap-1.5 mt-0.5">
                    <Flame size={10} className="text-[var(--accent)]" /> {u.streak || 0}
                  </div>
                </div>
              </div>
              <div className="font-display text-3xl tabular-nums flex items-center gap-1.5 tracking-tight">
                <Trophy size={15} className="text-[var(--emerald)]" /> {u.xp || 0}
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
